import './styles/App.css';
import ResumeContainer from './components/Resume';

function App() {
  return (
    <div className="app">
        <ResumeContainer />
    </div>
  );
}

export default App;
